@if (showModal()) {
<app-modal (closeModal)="close()">
  <h1 modal-title>{{ buttonText }} Proveedor</h1>

  <form
    [formGroup]="supplierForm"
    (submit)="submit()"
    class="flex flex-col gap-4"
    modal-content
  >
    <div class="flex flex-col gap-2">
      <label for="supplier-name">Nombre del Proveedor</label>
      <input
        type="text"
        id="supplier-name"
        formControlName="name"
        class="basic-input"
      />
    </div>

    <div class="flex flex-col gap-2">
      <label for="supplier-email">Correo Electrónico</label>
      <input
        type="email"
        id="supplier-email"
        formControlName="email"
        class="basic-input"
      />
    </div>

    <div class="flex flex-col gap-2">
      <label for="supplier-phone">Teléfono</label>
      <input
        type="tel"
        id="supplier-phone"
        formControlName="phone"
        class="basic-input"
      />
    </div>

    <div
      class="flex flex-col-reverse sm:flex-row sm:justify-between sm:space-x-2"
    >
      <button type="button" class="secondary normal" (click)="cancel()">
        Cancelar
      </button>

      <button
        type="submit"
        [disabled]="supplierForm.invalid"
        class="primary normal"
      >
        {{ buttonText }}
      </button>
    </div>

    @if (confirmationMessage && supplierForm.pristine) {
    <span class="mt-2 text-green-700 text-sm">{{ confirmationMessage }}</span>
    } @if (errorMessage && supplierForm.pristine) {
    <span class="mt-2 text-red-700 text-sm">{{ errorMessage }}</span>
    }
  </form>
</app-modal>
}
